(function() {
    'use strict';

    angular.module('ksef')
        .controller('KsefCompanyCertCreateController', KsefCompanyCertCreateController);

    KsefCompanyCertCreateController.$inject = [
        '$state',
        'notificationSrvc',
        'errorNotificationSrvc',
        'checkModelPermissionsSrvc',
        'ksefCompanyDataSrvc',
        'ksefCertificateDataSrvc',
        'ksefCertificateMessagesConst',
        'ksefCertificatePermissionsConst'
    ];

    function KsefCompanyCertCreateController(
        $state,
        notificationSrvc,
        errorNotificationSrvc,
        checkModelPermissionsSrvc,
        ksefCompanyDataSrvc,
        ksefCertificateDataSrvc,
        ksefCertificateMessagesConst,
        ksefCertificatePermissionsConst
    ) {
        var self = this;

        self.submitingForm = false;

        self.serverErrors = {
            company: [],
            label: [],
            cert_pem_file: [],
            key_pem_file: [],
            key_password: [],
            nonFieldErrors: []
        };

        self.companyData = {};

        self.certData = {
            company: null,
            label: null,
            cert_pem_file: null,
            key_pem_file: null,
            key_password: null
        };

        self.getCompany = getCompany;
        self.createCompanyCert = createCompanyCert;
        self.hasCertCreatePerm = hasCertCreatePerm;
        self.cleanErrors = cleanErrors;

        active()
        function active(){
            self.getCompany($state.params.pk);
        }

        function getCompany(companyPk) {
            self.loading = true;

            return ksefCompanyDataSrvc.get({pk: companyPk})
                .$promise
                .then(function (response) {
                    self.companyData = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.ksef-companies.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createCompanyCert() {
            if (!hasCertCreatePerm()) {
                return;
            }

            self.submitingForm = true;
            self.certData.company = self.companyData.pk;

            ksefCertificateDataSrvc.create(self.certData)
                .$promise
                .then(function() {
                    notificationSrvc.notification('success', ksefCertificateMessagesConst.add);
                    $state.go('layout.ksef-companies.detail', {pk: $state.params.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.submitingForm = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function hasCertCreatePerm(){
            return !checkModelPermissionsSrvc.isDenied(ksefCertificatePermissionsConst.add);
        }
    }
})();
